import React, { useEffect, useRef } from "react";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { IoMdPrint } from "react-icons/io";
import { checkAcessRights, formatWeight } from "../../../_helper/helper";
import { PRINT_ACCESS } from "../../../_contstants/common";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { getStockReport } from "../services/reports.services";

const StockReportView: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const CategoryID = params.CategoryID;
  const SubCategoryID = params.SubCategoryID;
  const ProductID = params.ProductID;
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.reports.loading);
  const StockReportReportList = useAppSelector(
    (state) => state.reports.StockReportReportList,
  );

  const isPrintAccess = checkAcessRights(
    "/ghat-karigar-ledger-report",
    PRINT_ACCESS,
  );

  const handleGetetStockReport = async (payload: any) => {
    await dispatch(getStockReport(payload));
  };

  useEffect(() => {
    if (CategoryID && SubCategoryID && ProductID) {
    const payload = {
        CategoryID: CategoryID || null,
        SubCategoryID: SubCategoryID || null,
        ProductID: ProductID || null,
    };
    handleGetetStockReport(payload);
    }
  }, []);

  const printTable = () => {
    window.print();
    return;
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <GridLayoutItem>
            <div
              className="printbuttons"
              style={{
                textAlign: "center",
                padding: "20px",
                display: "block",
              }}
            >
              {isPrintAccess && (
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={printTable}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              )}
            </div>
          </GridLayoutItem>
          <GridLayoutItem>
            <Typography.h5
              style={{
                marginBottom: 5,
                textAlign: "center",
              }}
            >
              Stock Report
            </Typography.h5>
          </GridLayoutItem>
        </GridLayoutItem>
        <GridLayoutItem>
          <div className="table-responsive"
            style={{
              scrollbarWidth: "thin",
              margin: 10,
              fontSize: "12px",
            }}
          >
            <table className="table table-striped table-bordered table-hover field-array-table">
              <thead>
                <tr>
                  <th className="text-center">Sr. No.</th>
                  <th className="text-center">Product Name</th>
                  <th className="text-center">Product Category</th>
                  <th className="text-center">Product SubCategory</th>
                  <th className="text-center">Purity</th>
                  <th className="text-center">Material Type</th>
                  <th className="text-center">Total Weight</th>
                  <th className="text-center">Total Qty</th>
                </tr>
              </thead>
              <tbody>
                {StockReportReportList?.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">{item.ProductName}</td>
                    <td className="text-center">{item.ProductCategory}</td>
                    <td className="text-center">{item.ProductsubCategory}</td>
                    <td className="text-center">{item.Purity}</td>
                    <td className="text-center">{item.material_type}</td>
                    <td className="text-center">
                      {formatWeight(item.total_weight)}
                    </td>
                    <td className="text-center">
                      {formatWeight(item.total_qty)}
                    </td>
                  </tr>
                ))}

                {/* Calculate totals - preserving your exact style */}
                <tr
                  style={{
                    fontSize: "16px",
                    borderTop: "2px solid darkgray",
                    backgroundColor: "#c2c2c2",
                  }}
                >
                  <th colSpan={6} className="text-end">
                    Total:
                  </th>
                  <th className="text-center">
                    {StockReportReportList && StockReportReportList.length > 0
                      ? formatWeight(
                          StockReportReportList?.reduce(
                            (sum, item) => sum + (Number(item.total_weight) || 0),
                            0,
                          )
                        )
                      : "0.000"}
                  </th>
                  <th className="text-center">
                    {StockReportReportList && StockReportReportList.length > 0
                      ? formatWeight(
                          StockReportReportList?.reduce(
                            (sum, item) => sum + (Number(item.total_qty) || 0),
                            0,
                          )
                        )
                      : "0.000"}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default StockReportView;
